import { render } from "./KemView.vue?vue&type=template&id=6880459d&scoped=true"
import script from "./KemView.vue?vue&type=script&lang=js"
export * from "./KemView.vue?vue&type=script&lang=js"

import "./KemView.vue?vue&type=style&index=0&id=6880459d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Дентакорплюс\\dentakor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6880459d"]])

export default __exports__